// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
=============== 
Tours
===============
*/

main.tourlist {
    width: 90vw;
    max-width: var(--fixed-width);
    margin: 5rem auto;
}

.loading {
    text-align: center;
}

.title {
    text-align: center;
    margin-bottom: 4rem;
}

.underline {
    width: 6rem;
    height: 0.25rem;
    background: var(--clr-primary-5);
    margin-left: auto;
    margin-right: auto;
}

.single-tour {
    background: var(--clr-white);
    border-radius: var(--radius);
    margin: 2rem 0;
    box-shadow: var(--light-shadow);
    transition: var(--transition);
}

.single-tour:hover {
    box-shadow: var(--dark-shadow);
}

.single-tour img {
    width: 100%;
    height: 20rem;
    object-fit: cover;
    border-top-right-radius: var(--radius);
    border-top-left-radius: var(--radius);
}

.tour-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
}

.tour-info h4 {
    margin-bottom: 0;
}

.single-tour button {
    background: transparent;
    border-color: transparent;
    text-transform: capitalize;
    color: var(--clr-primary-5);
    font-size: 1rem;
    cursor: pointer;
    padding-left: 0.25rem;
}

.tour-price {
    color: var(--clr-primary-5);
    background: var(--clr-primary-10);
    padding: 0.25rem 0.5rem;
    border-radius: var(--radius);
}

.single-tour footer {
    padding: 1.5rem 2rem;
}

.single-tour .delete-btn {
    display: block;
    width: 200px;
    margin: 1rem auto 0 auto;
    color: var(--clr-red-dark);
    letter-spacing: var(--spacing);
    background: transparent;
    border: 1px solid var(--clr-red-dark);
    padding: 0.25rem 0.5rem;
    border-radius: var(--radius);
}`, "",{"version":3,"sources":["webpack://./src/tour/tourlist.css"],"names":[],"mappings":"AAAA;;;;CAIC;;AAED;IACI,WAAW;IACX,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gCAAgC;IAChC,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,4BAA4B;IAC5B,cAAc;IACd,+BAA+B;IAC/B,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,sCAAsC;IACtC,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,0BAA0B;IAC1B,2BAA2B;IAC3B,eAAe;IACf,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;IAC3B,iCAAiC;IACjC,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,wBAAwB;IACxB,0BAA0B;IAC1B,8BAA8B;IAC9B,uBAAuB;IACvB,qCAAqC;IACrC,uBAAuB;IACvB,4BAA4B;AAChC","sourcesContent":["/*\r\n=============== \r\nTours\r\n===============\r\n*/\r\n\r\nmain.tourlist {\r\n    width: 90vw;\r\n    max-width: var(--fixed-width);\r\n    margin: 5rem auto;\r\n}\r\n\r\n.loading {\r\n    text-align: center;\r\n}\r\n\r\n.title {\r\n    text-align: center;\r\n    margin-bottom: 4rem;\r\n}\r\n\r\n.underline {\r\n    width: 6rem;\r\n    height: 0.25rem;\r\n    background: var(--clr-primary-5);\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n}\r\n\r\n.single-tour {\r\n    background: var(--clr-white);\r\n    border-radius: var(--radius);\r\n    margin: 2rem 0;\r\n    box-shadow: var(--light-shadow);\r\n    transition: var(--transition);\r\n}\r\n\r\n.single-tour:hover {\r\n    box-shadow: var(--dark-shadow);\r\n}\r\n\r\n.single-tour img {\r\n    width: 100%;\r\n    height: 20rem;\r\n    object-fit: cover;\r\n    border-top-right-radius: var(--radius);\r\n    border-top-left-radius: var(--radius);\r\n}\r\n\r\n.tour-info {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 1.5rem;\r\n}\r\n\r\n.tour-info h4 {\r\n    margin-bottom: 0;\r\n}\r\n\r\n.single-tour button {\r\n    background: transparent;\r\n    border-color: transparent;\r\n    text-transform: capitalize;\r\n    color: var(--clr-primary-5);\r\n    font-size: 1rem;\r\n    cursor: pointer;\r\n    padding-left: 0.25rem;\r\n}\r\n\r\n.tour-price {\r\n    color: var(--clr-primary-5);\r\n    background: var(--clr-primary-10);\r\n    padding: 0.25rem 0.5rem;\r\n    border-radius: var(--radius);\r\n}\r\n\r\n.single-tour footer {\r\n    padding: 1.5rem 2rem;\r\n}\r\n\r\n.single-tour .delete-btn {\r\n    display: block;\r\n    width: 200px;\r\n    margin: 1rem auto 0 auto;\r\n    color: var(--clr-red-dark);\r\n    letter-spacing: var(--spacing);\r\n    background: transparent;\r\n    border: 1px solid var(--clr-red-dark);\r\n    padding: 0.25rem 0.5rem;\r\n    border-radius: var(--radius);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
